import React from 'react'

const Share = ({ className }) => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    viewBox="0 0 22 18"
    className={className}
  >
    <path
      fillRule="evenodd"
      fill="currentColor"
      d="M21.229 7.15L13.055.689a.63.63 0 00-1.022.496v2.347a.841.841 0 01-.816.838C5.632 4.583-.868 9.118.658 18c0 0 1.074-6.634 10.707-7.082a.637.637 0 01.668.635v2.554a.63.63 0 001.022.496l8.174-6.461a.633.633 0 000-.992z"
    />
  </svg>
)

export default Share
